import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions'
import Header from "../common/Header";
import Footer from "../common/Footer";
import SecondFooter from "../common/SecondFooter";
import $ from 'jquery';
import { setCookie } from "../../utils/tools/cookies"
import { ssoUrl } from "../../common/baseConfig";

/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/
class App extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    children: PropTypes.node,
    commonActions: PropTypes.object.isRequired,
  };
  static defaultProps = {
    children: '',
  };
  componentWillMount() {
    localStorage.setItem('needSys403Warn', true);
    //单点登录
    if (this.props.history.location.search.split('PromotersCode=')[1]) {
      localStorage.removeItem('PromotersCode');
      localStorage.setItem('PromotersCode', this.props.history.location.search.split('PromotersCode=')[1])
    }
    if (this.props.history.location.pathname !== '/login' && !localStorage.getItem('studentinfo')) {
      this.checkLogin('');
    }
    //自定义事件监听 监听所有localstorage新增
    var orignalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, newValue) {
      var setItemEvent = new Event("setItemEvent");
      setItemEvent.key = key;
      setItemEvent.newValue = newValue;
      window.dispatchEvent(setItemEvent);
      orignalSetItem.apply(this, arguments);
    }
  }
  checkLogin(token) {
    this.props.actions.fetchGetStuInfoBySId({ token }).then(res => {
      if (res.SuccessResponse && res.Data) {
        //已登录
        const { StuID, Name, Phone } = res.Data
        this.props.commonActions.fetchStudentBasics({ StuID })
        // message.success('登录成功');
        setCookie('UserKey', StuID);
        setCookie('UserNameKey', Name);
        setCookie('UserPhoneKey', Phone);
        localStorage.setItem('studentinfo', JSON.stringify(res.Data));
        this.props.history.push('/center');
      } else {
        this.checkSSOLogin();
      }
    })
  }
  checkSSOLogin() {

    let that = this;
    $.ajax({
      type: "POST",
      url: ssoUrl + "/sso/ssostudent/checkLogin",
      xhrFields: { withCredentials: true },
      crossDomain: true,
      success: function (rs) {
        if (rs.SuccessResponse) {
          let token = rs.Data;
          that.checkLogin(token);
        }
      }
    })
  }
  componentDidMount() {
    this.props.commonActions.fetchGetHeader();
    const studentinfo = JSON.parse(localStorage.getItem('studentinfo'))
    this.props.commonActions.fetchConfigInfo().then(res => {
      document.getElementsByTagName("title")[0].innerHTML =
        res.HeaderName;
      document.getElementById("icoFont").href = res.Favicon;
    });
    if (studentinfo && studentinfo.StuID) {
      const { StuID } = studentinfo
      this.props.commonActions.fetchStudentBasics({ StuID })
    }
  }
  render() {
    const { location } = this.props.history
    let isShowFooter = true
    if (location.pathname.includes('/chapter/') || location.pathname.includes('/exam/')) {
      isShowFooter = false
    }
    return (
      <div className="home-app">
        <Header {...this.props} />
        <div className="page-container">{this.props.children}</div>
        {
          isShowFooter ? <SecondFooter /> : ''
        }
        {
          isShowFooter ? <Footer /> : ''
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/features/home/App.js